<template v-if="!isLoading">
  <div
    class="alert text-center p-0 m-0"
    style="
      background: linear-gradient(
        90deg,
        rgba(243, 243, 243, 1) 0%,
        rgba(252, 202, 207, 1) 48%,
        rgba(243, 243, 243, 1) 100%
      );
    "
    v-if="this.getDiscountTariffPriceList().length != 0"
    role="alert"
    @click="showDiscountSessionsModal"
  >
    <strong class="blinkText" style="cursor: pointer"
      ><svg
        width="18px"
        height="18px"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        class="bi bi-percent"
        viewBox="0 0 16 16"
      >
        <path
          d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
        ></path>
      </svg>
      تخفیف</strong
    >
  </div>
  <div>
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>
    <div
      class="container"
      style="min-height: 78vh"
      :class="isMobile ? 'bg-mainPanel' : ''"
    >
      <div
        class="alert alert-danger my-1 text-center"
        role="alert"
        v-if="
          $store.state.inMaintenance === true ||
          $store.state.inMaintenance === 'true'
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
          viewBox="0 0 16 16"
          role="img"
          aria-label="Warning:"
        >
          <path
            d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
          />
        </svg>
        سامانه در حال به روز رسانی است و دسترسی به عملیات های آن محدود می باشد
      </div>
      <!-- <div class="row">
        <div
          class="col-12 col-12"
          :class="isMobile ? '' : 'p-0 pe-2'"
          v-if="this.$store.getters.isOverseas === false"
        >
          <div
            class="my-1 text-center me-2 mb-0 alert alert-primary"
            role="alert"
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              مراجع گرامی، شما می‌توانید پیشاپیش جلسات مورد نیاز خود را تا پایان
              آذرماه ۱۴۰۳ ثبت نمایید.
            </div>
          </div>
        </div>
      </div> -->

      <div v-if="isMobile" style="display: contents">
        <div class="d-flex row px-3 justify-content-between mt-2">
          <div
            class="row p-0 sss"
            style="padding-right: 5px !important"
            :class="
              this.$router.currentRoute.value.path.includes('panel') &&
              !this.$router.currentRoute.value.path.includes('invoiceList') &&
              !this.$router.currentRoute.value.path.includes('finalConfirm')
                ? 'col-8'
                : 'col-9'
            "
          >
            <div
              class="avatar rounded-circle text-primary text-white col-1"
              v-if="!isMobile"
              :class="!hasProfilePic ? 'blueBackground' : ''"
              :style="
                hasProfilePic
                  ? `border:1px solid #3d4964;background-image:${demoImageUrl}`
                  : ''
              "
            >
              <svg
                v-if="!hasProfilePic"
                class="text-gray-300"
                width="34px"
                height="34px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 460.8 460.8"
                fill="currentColor"
              >
                <path
                  d="M230.432,0c-65.829,0-119.641,53.812-119.641,119.641s53.812,119.641,119.641,119.641s119.641-53.812,119.641-119.641S296.261,0,230.432,0z"
                ></path>
                <path
                  d="M435.755,334.89c-3.135-7.837-7.314-15.151-12.016-21.943c-24.033-35.527-61.126-59.037-102.922-64.784c-5.224-0.522-10.971,0.522-15.151,3.657c-21.943,16.196-48.065,24.555-75.233,24.555s-53.29-8.359-75.233-24.555c-4.18-3.135-9.927-4.702-15.151-3.657c-41.796,5.747-79.412,29.257-102.922,64.784c-4.702,6.792-8.882,14.629-12.016,21.943c-1.567,3.135-1.045,6.792,0.522,9.927c4.18,7.314,9.404,14.629,14.106,20.898c7.314,9.927,15.151,18.808,24.033,27.167c7.314,7.314,15.673,14.106,24.033,20.898c41.273,30.825,90.906,47.02,142.106,47.02s100.833-16.196,142.106-47.02c8.359-6.269,16.718-13.584,24.033-20.898c8.359-8.359,16.718-17.241,24.033-27.167c5.224-6.792,9.927-13.584,14.106-20.898C436.8,341.682,437.322,338.024,435.755,334.89z"
                ></path>
              </svg>
              <img
                v-else
                style="
                  height: 3.125rem;
                  min-width: 3.125rem;
                  border-radius: 50px;
                "
                class="image"
                :src="demoImageUrl"
                alt="مرکز مشاوره و روان‌شناسی ارگانیک مایندد"
              />
            </div>
            <div class="dropdown pt-3 pe-1 col-9">
              <a
                class="dropdown-toggle blueText"
                href="#"
                role="button"
                id="exDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="fi fi-bars-2 ms-2" v-if="isMobile"></i>
                <span>{{ this.$store.getters.clientFullName }}</span>
                <span
                  style="position: relative; top: 2px; right: 2px"
                  v-if="!isMobile"
                  >▼</span
                >
              </a>

              <ul class="dropdown-menu shadow" aria-labelledby="exDropdown">
                <li>
                  <a
                    class="dropdown-item"
                    :href="'/panel/userPanel/' + getPersonID"
                    v-if="
                      !this.$router.currentRoute.value.path.includes(
                        'panel/userPanel'
                      )
                    "
                  >
                    <span>پنل کاربری</span>
                  </a>
                </li>
                <li v-if="false">
                  <a
                    class="dropdown-item"
                    :href="`/panel/userProfileTab/${$store.getters.userPersonID}`"
                    v-if="
                      !this.$router.currentRoute.value.path.includes(
                        'userProfileTab'
                      )
                    "
                  >
                    <span>حساب کاربری</span>
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    :href="`/panel/messagesTab/${$store.getters.userPersonID}`"
                    v-if="
                      !this.$router.currentRoute.value.path.includes(
                        'messagesTab'
                      )
                    "
                  >
                    <span
                      >پیام های دریافتی
                      <span
                        class="position-absolute me-1 right-0 top-0 mt-1 p-1 bg-danger border border-light rounded-circle"
                        v-if="getHasUnseenMessage"
                      >
                        <span class="visually-hidden">پیام جدید</span>
                      </span></span
                    >
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    @click="this.showClientChooseDialog()"
                    href="#"
                    v-if="checkMultipleClients()"
                  >
                    <span>تغییر کاربر</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="https://www.aparat.com/v/rty1lve"
                    id=""
                    class="dropdown-item"
                    v-if="isMobile"
                    target="_blank"
                  >
                    راهنمای امکانات سایت
                  </a>
                </li>

                <li>
                  <a class="dropdown-item" @click="contactUsClick" href="#">
                    <span>ارتباط با مدیر فنی</span>
                  </a>
                </li>
                <div class="dropdown-divider mt-3"></div>
                <li class="text-danger">
                  <a
                    href="#"
                    title="Log Out"
                    class="dropdown-item mt-1 text-danger"
                    @click="logout"
                  >
                    <i class="fi fi-power m-0"></i>
                    <span>خروج</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-1 p-0 text-center">
            <a
              v-if="this.$router.currentRoute.value.path.includes('panel')"
              class="btn btn-light rounded bg-transparent transition-hover-bottom mb-1 px-0"
              style="border-color: transparent"
              href="/"
            >
              <svg
                width="18px"
                height="18px"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-house"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                ></path>
                <path
                  fill-rule="evenodd"
                  d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
                ></path>
              </svg>
            </a>
          </div>
          <div
            class="col-1 p-0 text-center"
            v-if="
              this.$router.currentRoute.value.path.includes('panel') &&
              !this.$router.currentRoute.value.path.includes('invoiceList') &&
              !this.$router.currentRoute.value.path.includes('finalConfirm')
            "
          >
            <a
              aria-label="Reserve Basket Options"
              id="dropdownRerserveBasketOptions"
              class="btn btn-light rounded bg-transparent transition-hover-bottom px-0"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              aria-haspopup="true"
              style="border-color: transparent"
            >
              <svg
                width="18px"
                height="18px"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-cart2"
                viewBox="0 0 16 16"
              >
                <path
                  d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
                ></path>
              </svg>
              <span
                class="bg-danger badgheNotification"
                :style="isMobile ? 'left:10px' : ''"
                v-if="
                  this.semiReserveListCount() > 0 &&
                  !this.$router.currentRoute.value.path.includes('finalConfirm')
                "
              ></span>
            </a>
            <!-- dropdown reserve basket -->
            <div
              aria-labelledby="dropdownRerserveBasketOptions"
              class="list-unstyled dropdown-menu dropdown-menu-clean dropdown-click-ignore end-0 py-2 rounded-xl"
              :class="this.semiReserveListCount() == 0 ? 'p-5' : 'p-1'"
              ref="dropdownRerserveBasketOptions"
            >
              <div v-if="this.semiReserveListCount() <= 0">
                <svg
                  width="32px"
                  height="32px"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="bi bi-cart-x d-block m-auto"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7.354 5.646 8.5 6.793l1.146-1.147a.5.5 0 0 1 .708.708L9.207 7.5l1.147 1.146a.5.5 0 0 1-.708.708L8.5 8.207 7.354 9.354a.5.5 0 1 1-.708-.708L7.793 7.5 6.646 6.354a.5.5 0 1 1 .708-.708z"
                  ></path>
                </svg>
                <h6 class="mt-3">جلسه‌ای به منظور رزرو وجود ندارد.</h6>
              </div>
              <div
                v-if="
                  !this.$router.currentRoute.value.path.includes(
                    'finalConfirm'
                  ) &&
                  !this.$router.currentRoute.value.path.includes(
                    'invoiceList'
                  ) &&
                  this.semiReserveListCount() > 0
                "
              >
                <div class="reserveBasket scrollable-styled-dark">
                  <div
                    class="card"
                    v-for="session in this.semiReserveList()"
                    :key="session.sessionID"
                  >
                    <div class="p-1" style="background-color: #f3f3f3">
                      <button
                        @click="cancelReserveSession(session.sessionID)"
                        class="btn btn-outline-danger p-1 float-end"
                        style="font-size: 12px"
                      >
                        <svg
                          width="16px"
                          height="16px"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          class="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                          ></path>
                        </svg>
                        حذف
                      </button>
                      <p class="m-0 p-1">
                        <span>{{ session.therapistName }} </span>
                        <small
                          class="gregorianDateClass"
                          style="unicode-bidi: embed"
                        >
                          ({{ getGregorianDateOfSession(session.date) }})
                        </small>
                        <span class="me-1">
                          {{ getPersianDate(session.date) }}</span
                        >
                      </p>
                    </div>
                    <div class="row px-3 mt-2">
                      <div class="col-6">
                        <span class="fw-bold">نوع جلسه: </span>
                        <span>{{
                          session.sessionTypeID == 1 ? 'حضوری' : 'غیرحضوری'
                        }}</span>
                      </div>
                      <div class="col-6">
                        <span class="fw-bold">نوع درمان:</span>
                        <span> {{ session.therapyTypeTitle }} </span>
                      </div>
                      <div class="col-6">
                        <span class="fw-bold">از: </span>
                        <span>{{ getHourAndMinute(session.fromTime) }}</span>
                      </div>
                      <div class="col-6">
                        <span class="fw-bold">تا: </span>
                        <span>{{ getHourAndMinute(session.toTime) }}</span>
                      </div>
                      <div class="col-6" v-if="!session.isCancelable">
                        <span class="fw-bold">قابل لغو:</span>
                        <span
                          :class="
                            session.isCancelable
                              ? 'text-success'
                              : 'text-danger'
                          "
                          ><i
                            class="fi mdi-check"
                            v-if="session.isCancelable"
                          ></i>
                          <i class="fi mdi-close" v-else></i
                          >{{ session.isCancelable ? 'بلی' : 'خیر' }}</span
                        >
                      </div>
                      <div class="col-12">
                        <span class="fw-bold">تعرفه: </span>
                        <span
                          >{{ session.tariffType }} -
                          <span v-if="session.discountPercent == 0">
                            {{ thousandSeprator(session.price, ',', '.') }}
                            {{ session.currencyTypeTitle }}
                          </span>
                          <span v-else>
                            {{
                              thousandSeprator(
                                session.price -
                                  (session.price * session.discountPercent) /
                                    100,
                                ',',
                                '.'
                              )
                            }}
                            {{ session.currencyTypeTitle }}
                            <span
                              class="text-success"
                              v-if="session.discountPercent != 0"
                              >(کد تخفیف)</span
                            >
                          </span></span
                        >
                      </div>
                      <div class="col-12" v-if="session.sessionTypeID != 2">
                        <span class="fw-bold">آدرس: </span>
                        <span>{{ session.centerName }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="dropdown-divider mt-3"
                  style="border-top-color: gray"
                ></div>
                <div class="totalResultReserveBasket">
                  <button
                    class="btn btn-sm btn-danger"
                    style="font-size: 16px; float: left"
                    @click="
                      this.$router.push({
                        name: 'finalConfirm',
                        params: { id: this.$store.getters.userPersonID },
                      })
                    "
                  >
                    <svg
                      width="16px"
                      height="16px"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      class="bi bi-check-circle-fill ms-1"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                      ></path>
                    </svg>
                    ثبت
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-1 p-0 text-center">
            <a
              v-if="this.$router.currentRoute.value.path.includes('panel')"
              class="btn btn-light rounded bg-transparent transition-hover-bottom mb-1 px-0"
              style="border-color: transparent"
              :href="`/panel/messagesTab/${$store.getters.userPersonID}`"
            >
              <svg
                width="18px"
                height="18px"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-envelope"
                viewBox="0 0 16 16"
              >
                <path
                  d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"
                ></path>
              </svg>
              <span
                class="position-absolute right-0 top-0 me-3 mt-2 p-1 bg-danger border border-light rounded-circle"
                v-if="getHasUnseenMessage"
              >
                <span class="visually-hidden">پیام جدید</span>
              </span>
            </a>
          </div>

          <div class="col-1 p-0 text-center">
            <a
              v-if="this.$router.currentRoute.value.path.includes('panel')"
              class="btn btn-light rounded bg-transparent transition-hover-bottom mb-1 px-0 text-danger"
              style="border-color: transparent"
              @click="logout"
            >
              <i class="fi fi-power m-0"></i>
            </a>
          </div>
        </div>
        <div class="p-2" v-if="false">
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-wallet2"
            viewBox="0 0 16 16"
          >
            <path
              d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484L5.562 3zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"
            ></path>
          </svg>
          موجودی:
          <div
            v-for="(w, index) in walletList"
            :key="w.id"
            class="d-inline-block"
          >
            <div class="fs12px">
              <!-- <i class="fi fi-arrow-left-full ms-2"></i> -->
              <i v-if="index != 0" class="fi fi-minus mx-1"></i>
              <span
                >{{ getFormatedBalance(w.balance) }} ({{
                  w?.wallet_CurrencyType?.title
                }})</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row g-4 pt-1">
        <div class="col-12 col-lg-2" v-if="!isMobile">
          <nav
            class="nav-deep nav-deep-light js-ajaxified js-stickified pnael-menu"
          >
            <div class="card card bg-RightMenu text-white">
              <div class="card-body p-3">
                <!-- mobile only -->
                <button
                  class="clearfix btn btn-toggle btn-sm w-100 text-align-left shadow-md border rounded d-block d-lg-none js-togglified text-white"
                  data-bs-target="#nav_responsiveMenu"
                  data-toggle-container-class="d-none d-sm-block bg-white shadow-md border animate-fadein rounded p-3"
                  @click="btnMenuClick"
                >
                  <span class="group-icon px-2 py-2 float-start">
                    <i class="fi fi-bars-2" v-if="!isMenueActive"></i>
                    <i class="fi fi-close" v-if="isMenueActive"></i>
                  </span>

                  <span class="h5 py-2 m-0 float-start text-white"
                    >دسترسی ها</span
                  >
                </button>

                <!-- navbar : navigation -->
                <ul
                  id="nav_responsiveMenu"
                  ref="nav_responsiveMenu"
                  class="nav flex-column d-lg-block mt-1 mt-lg-0 d-none"
                >
                  <li>
                    <!-- account name -->
                    <div
                      class="d-flex align-items-center text-center justify-content-center"
                      v-if="false"
                    >
                      <div
                        class="border rounded-circle"
                        :class="hasProfilePic ? 'p-0' : 'p-3'"
                      >
                        <svg
                          v-if="!hasProfilePic"
                          class="text-gray-300"
                          width="34px"
                          height="34px"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 460.8 460.8"
                          fill="currentColor"
                        >
                          <path
                            d="M230.432,0c-65.829,0-119.641,53.812-119.641,119.641s53.812,119.641,119.641,119.641s119.641-53.812,119.641-119.641S296.261,0,230.432,0z"
                          ></path>
                          <path
                            d="M435.755,334.89c-3.135-7.837-7.314-15.151-12.016-21.943c-24.033-35.527-61.126-59.037-102.922-64.784c-5.224-0.522-10.971,0.522-15.151,3.657c-21.943,16.196-48.065,24.555-75.233,24.555s-53.29-8.359-75.233-24.555c-4.18-3.135-9.927-4.702-15.151-3.657c-41.796,5.747-79.412,29.257-102.922,64.784c-4.702,6.792-8.882,14.629-12.016,21.943c-1.567,3.135-1.045,6.792,0.522,9.927c4.18,7.314,9.404,14.629,14.106,20.898c7.314,9.927,15.151,18.808,24.033,27.167c7.314,7.314,15.673,14.106,24.033,20.898c41.273,30.825,90.906,47.02,142.106,47.02s100.833-16.196,142.106-47.02c8.359-6.269,16.718-13.584,24.033-20.898c8.359-8.359,16.718-17.241,24.033-27.167c5.224-6.792,9.927-13.584,14.106-20.898C436.8,341.682,437.322,338.024,435.755,334.89z"
                          ></path>
                        </svg>
                        <img
                          v-else
                          style="height: 68px; border-radius: 50px; width: 68px"
                          class="image"
                          :src="demoImageUrl"
                          alt="مرکز مشاوره و روان‌شناسی ارگانیک مایندد"
                        />
                      </div>
                    </div>
                    <div class="border-bottom text-center">
                      <!-- <span>درود</span> -->
                      <span class="d-block fw-bold mt-1">
                        {{ getUserFullName }}
                        <a
                          v-if="false"
                          :href="`/panel/userProfileTab/${$store.getters.userPersonID}`"
                          ><i class="fi fi-pencil text-light me-1"></i>
                        </a>
                      </span>

                      <span
                        class="d-block fs11px mt-1"
                        v-if="getClientOverseas()"
                      >
                        {{ getClientEmail() ?? '' }}
                      </span>
                      <span class="d-block fs11px mt-1" v-if="getClientPhone()">
                        {{ getClientPhone() ?? '' }}
                      </span>
                      <span class="d-block mt-1">
                        {{ getClientCode }}
                      </span>
                    </div>
                  </li>
                  <!-- ثبت جلسه -->
                  <!-- :class="
                      this.$router.currentRoute.value.fullPath.includes(
                        'selectTherapist'
                      )
                        ? 'active'
                        : ''
                    " -->
                  <li
                    class="nav-item transition-all-ease-500 transition-hover-left"
                    :class="
                    this.$router.currentRoute.value.fullPath.includes(
                        'reservingSessionTab'
                      ) && !this.$router.currentRoute.value.fullPath.includes(
                        'invoiceList'
                      )
                        ? 'active'
                        : ''
                    "
                  >
                    <!-- :href="`/panel/reservingSessionTab/selectTherapist/${$store.getters.userPersonID}`" -->
                    <a
                      class="nav-link px-0 d-flex align-items-center pointer"
                      @click="reservingSessionButtonClick"
                    >
                      <svg
                        width="18px"
                        height="18px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-clock-history ms-2"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"
                        ></path>
                        <path
                          d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"
                        ></path>
                        <path
                          d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"
                        ></path>
                      </svg>
                      <span>جلسه درمانی</span>
                    </a>
                  </li>
                  <!-- جلسه تست -->
                  <!-- :class="
                      this.$router.currentRoute.value.fullPath.includes(
                        'selectTestSession'
                      )
                        ? 'active'
                        : ''
                    " -->
                  <li
                    class="nav-item transition-all-ease-500 transition-hover-left"
                    :class="
                      this.$router.currentRoute.value.fullPath.includes(
                        'reservingSessionTestTab'
                      )
                        ? 'active'
                        : ''
                    "
                  >
                    <!-- :href="`/panel/reservingSessionTab/selectTestSession/${$store.getters.userPersonID}`" -->
                    <a
                      class="nav-link px-0 d-flex align-items-center pointer"
                      @click="reserveTestButtonClick"
                    >
                      <svg
                        width="18px"
                        height="18px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-journal-check ms-2"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                        ></path>
                        <path
                          d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                        ></path>
                        <path
                          d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                        ></path>
                      </svg>
                      <span>تست و ارزیابی</span>
                    </a>
                  </li>

                  <!-- ثبت گروه درمانی -->
                  <!-- :class="
                      this.$router.currentRoute.value.name.includes(
                        'workshopTab'
                      ) && this.$router.currentRoute.value.path.endsWith('1')
                        ? 'active'
                        : ''
                    " -->
                  <li
                    class="nav-item transition-all-ease-500 transition-hover-left"
                    :class="this.$router.currentRoute.value.name.includes(
                        'workshopTab'
                      ) && this.$router.currentRoute.value.params.type == 1
                        ? 'active'
                        : ''
                    "
                  >
                    <a
                      class="nav-link px-0 d-flex align-items-center pointer"
                      @click="groupTherapyButtonClick"
                    >
                      <svg
                        width="18px"
                        height="18px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-people ms-2"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                        ></path>
                      </svg>
                      <span>گروه درمانی</span>
                      <!-- <span
                          class="position-absolute fs10px top-0 end-10 translate-middle badge rounded-pill bg-danger"
                        >
                          بزودی ...
                          <span class="visually-hidden">unread messages</span>
                        </span> -->
                    </a>
                  </li>
                  <!-- ثبت کارگاه آموزشی -->
                  <!-- :class="
                      this.$router.currentRoute.value.name.includes(
                        'workshopTab'
                      ) && this.$router.currentRoute.value.path.endsWith('2')
                        ? 'active'
                        : ''
                    " -->
                  <li
                    class="nav-item transition-all-ease-500 transition-hover-left"
                    :class="
                      this.$router.currentRoute.value.name.includes(
                        'workshopTab'
                      ) && this.$router.currentRoute.value.params.type == 2
                        ? 'active'
                        : ''
                    "
                  >
                    <a
                      class="nav-link px-0 d-flex align-items-center pointer"
                      @click="workshopButtonClick"
                    >
                      <svg
                        width="18px"
                        height="18px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-person-workspace ms-2"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M4 16s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H4Zm4-5.95a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
                        ></path>
                        <path
                          d="M2 1a2 2 0 0 0-2 2v9.5A1.5 1.5 0 0 0 1.5 14h.653a5.373 5.373 0 0 1 1.066-2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v9h-2.219c.554.654.89 1.373 1.066 2h.653a1.5 1.5 0 0 0 1.5-1.5V3a2 2 0 0 0-2-2H2Z"
                        ></path>
                      </svg>
                      <span class="fs15px">کارگاه آموزشی</span>
                      <!-- <span
                          class="position-absolute fs10px top-0 end-10 translate-middle badge rounded-pill bg-danger"
                        >
                          بزودی ...
                          <span class="visually-hidden">unread messages</span>
                        </span> -->
                    </a>
                  </li>

                  <!-- جلسات -->
                  <!-- :class="
                      this.$router.currentRoute.value.name.includes(
                        'sessionsTab'
                      )
                        ? 'active'
                        : ''
                    " -->
                  <li
                    class="nav-item transition-all-ease-500 transition-hover-left"
                    :class="
                      this.$router.currentRoute.value.name.includes(
                        'sessionsTab'
                      )
                        ? 'active'
                        : ''
                    "
                  >
                    <!-- :href="`/panel/sessionsTab/${$store.getters.userPersonID}`" -->
                    <a
                      class="nav-link px-0 d-flex align-items-center pointer"
                      @click="sesstionButtonClick"
                    >
                      <svg
                        class="float-start"
                        width="18px"
                        height="18px"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                        ></path>
                        <path
                          fill-rule="evenodd"
                          d="M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3zm4.354 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                        ></path>
                      </svg>
                      <span>سوابق جلسات</span>
                    </a>
                  </li>
                  <!-- کیف پول -->
                  <!-- :class="
                      this.$router.currentRoute.value.name.includes('walletTab')
                        ? 'active'
                        : ''
                    " -->
                  <li
                    class="nav-item transition-all-ease-500 transition-hover-left"
                    :class="
                      this.$router.currentRoute.value.name.includes(
                        'walletTab'
                      )
                        ? 'active'
                        : ''
                    "
                  >
                    <!-- :href="`/panel/walletTab/${$store.getters.userPersonID}`" -->
                    <a
                      class="nav-link px-0 d-flex align-items-center pointer"
                      @click="walletButtonClick"
                    >
                      <svg
                        class="float-start"
                        width="18px"
                        height="18px"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                      >
                        <path
                          d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"
                        ></path>
                        <path
                          d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"
                        ></path>
                      </svg>

                      <span>کیف پول</span>
                    </a>
                  </li>
                  <!-- گزارش تخطی -->
                  <!-- :class="
                      this.$router.currentRoute.value.name.includes(
                        'violationReportTab'
                      )
                        ? 'active'
                        : ''
                    " -->
                  <li
                    class="nav-item transition-all-ease-500 transition-hover-left"
                    :class="
                      this.$router.currentRoute.value.name.includes(
                        'violationReportTab'
                      )
                        ? 'active'
                        : ''
                    "
                  >
                    <!-- :href="`/panel/violationReportTab/${$store.getters.userPersonID}`" -->
                    <a
                      class="nav-link px-0 d-flex align-items-center fs-8 pointer"
                      @click="violationButtonClick"
                      id="reportTherapistFault"
                    >
                      <svg
                        class="float-start"
                        width="18px"
                        height="18px"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                      >
                        <path
                          d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
                        ></path>
                        <path
                          d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"
                        ></path>
                      </svg>

                      <span>گزارش خطای درمانگر</span>
                    </a>
                  </li>

                  <!-- کد تخفیف -->
                  <!-- :class="
                      this.$router.currentRoute.value.name.includes(
                        'discountCode'
                      )
                        ? 'active'
                        : ''
                    " -->
                  <li
                    class="nav-item transition-all-ease-500 transition-hover-left"
                    :class="
                      this.$router.currentRoute.value.name.includes(
                        'discountCode'
                      )
                        ? 'active'
                        : ''
                    "
                  >
                    <a
                      class="nav-link px-0 d-flex align-items-center fs-8 pointer"
                      @click="discountCodeButtonClick"
                    >
                      <svg
                        class="float-start"
                        width="18px"
                        height="18px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M7.84 4.1a.178.178 0 0 1 .32 0l.634 1.285a.178.178 0 0 0 .134.098l1.42.206c.145.021.204.2.098.303L9.42 6.993a.178.178 0 0 0-.051.158l.242 1.414a.178.178 0 0 1-.258.187l-1.27-.668a.178.178 0 0 0-.165 0l-1.27.668a.178.178 0 0 1-.257-.187l.242-1.414a.178.178 0 0 0-.05-.158l-1.03-1.001a.178.178 0 0 1 .098-.303l1.42-.206a.178.178 0 0 0 .134-.098L7.84 4.1z"
                        ></path>
                        <path
                          d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"
                        ></path>
                      </svg>

                      <span>کد تخفیف</span>
                    </a>
                  </li>

                  <li class="nav-item border-top my-2"></li>
                  <div class="border-bottom my-3 pb-3" v-if="false">
                    <div class="small mb-2 text-gray-300">
                      <svg
                        width="18px"
                        height="18px"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        class="bi bi-wallet ms-2"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M0 3a2 2 0 0 1 2-2h13.5a.5.5 0 0 1 0 1H15v2a1 1 0 0 1 1 1v8.5a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 0 12.5V3zm1 1.732V12.5A1.5 1.5 0 0 0 2.5 14h12a.5.5 0 0 0 .5-.5V5H2a1.99 1.99 0 0 1-1-.268zM1 3a1 1 0 0 0 1 1h12V2H2a1 1 0 0 0-1 1z"
                        ></path>
                      </svg>
                      موجودی:
                    </div>

                    <div v-for="w in walletList" :key="w.id">
                      <div class="fs12px">
                        <!-- <i class="fi fi-arrow-left-full ms-2"></i> -->
                        <i class="fi fi-arrow-left ms-2"></i>

                        <span
                          >{{ getFormatedBalance(w.balance) }} ({{
                            w?.wallet_CurrencyType?.title
                          }})</span
                        >
                      </div>
                    </div>
                  </div>

                  <li
                    class="nav-item transition-all-ease-500 transition-hover-left text-danger"
                  >
                    <a
                      class="px-0 fw-bold text-danger"
                      href="#"
                      @click="logout"
                    >
                      <i class="fi fi-power float-start"></i>
                      خروج
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
        <div
          class="col-12 col-lg-10 border rounded-3"
          :class="isMobile ? 'mb-4' : 'bg-mainPanel'"
        >
          <!-- :style="
            isMobile
              ? 'max-height:65vh;margin-top:0px ;margin-bottom: 5vh;'
              : ''
          " -->
          <!-- Router -->
          <router-view />
        </div>
      </div>
    </div>
  </div>

  <div style="position: sticky; bottom: 0px; z-index: 100">
    <!-- first nav -->
    <nav
      class="mobile-nav blueBackground border-bottom"
      style="bottom: 65px; box-shadow: none !important"
      v-if="isMobile"
    >
      <div class="row col-12">
        <div
          class="col-3 text-center fs-7 m-auto p-0"
          :class="
            this.$router.currentRoute.value.fullPath.includes(
                        'reservingSessionTab'
                      ) && !this.$router.currentRoute.value.fullPath.includes(
                        'invoiceList'
                      )
              ? 'mobile-nav-item-active'
              : ''
          "
        >
          <a
            @click="reservingSessionButtonClick"
            class="mobile-nav-item d-flex flex-column align-items-center"
            style="font-size: 0.7rem"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 16 16"
              class="mb-1"
            >
              <path
                d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"
              ></path>
              <path
                d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"
              ></path>
              <path
                d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"
              ></path>
            </svg>
            جلسه درمانی
          </a>
          <span></span>
        </div>
        <!-- :class="
            this.$router.currentRoute.value.fullPath.includes(
              'selectTestSession'
            )
              ? 'mobile-nav-item-active'
              : ''
          " -->
        <div
          class="col-3 text-center fs-7 m-auto p-0"
          :class="
            this.$router.currentRoute.value.fullPath.includes(
                        'reservingSessionTestTab'
                      )
              ? 'mobile-nav-item-active'
              : ''
          "
        >
          <a
            @click="reserveTestButtonClick"
            class="mobile-nav-item d-flex flex-column align-items-center"
            style="font-size: 0.7rem"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-journal-check ms-2 mb-1"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"
              ></path>
              <path
                d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
              ></path>
              <path
                d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
              ></path>
            </svg>
            تست و ارزیابی
          </a>
          <span></span>
        </div>
        <!-- :class="
            this.$router.currentRoute.value.fullPath.includes('workshopTab') &&
            this.$router.currentRoute.value.path.endsWith('1')
              ? 'mobile-nav-item-active'
              : ''
          " -->
        <div
          class="col-3 text-center fs-7 m-auto p-0"
          :class="
            this.$router.currentRoute.value.name.includes(
                        'workshopTab'
                      ) && this.$router.currentRoute.value.params.type == 1
              ? 'mobile-nav-item-active'
              : ''
          "
        >
          <a
            @click="groupTherapyButtonClick"
            class="mobile-nav-item d-flex flex-column align-items-center"
            style="font-size: 0.7rem"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-people mb-1"
              viewBox="0 0 16 16"
            >
              <path
                d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
              ></path>
            </svg>
            <span class="position-relative"
              >گروه درمانی

              <!-- <span
                class="position-absolute fs10px top-50N start-100 translate-middle badge rounded-pill bg-danger"
              >
                بزودی ...
                <span class="visually-hidden">unread messages</span>
              </span> -->
            </span>
          </a>
          <span></span>
        </div>
        <!-- :class="
            this.$router.currentRoute.value.fullPath.includes('workshopTab') &&
            this.$router.currentRoute.value.path.endsWith('2')
              ? 'mobile-nav-item-active'
              : ''
          " -->
        <div
          class="col-3 text-center fs-7 m-auto"
          :class="
            this.$store.getters.currentPanel == 'workshopList'
              ? 'mobile-nav-item-active'
              : ''
          "
        >
          <a
            @click="workshopButtonClick"
            class="mobile-nav-item d-flex flex-column align-items-center"
            style="font-size: 0.7rem"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-person-workspace mb-1"
              viewBox="0 0 16 16"
            >
              <path
                d="M4 16s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H4Zm4-5.95a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
              ></path>
              <path
                d="M2 1a2 2 0 0 0-2 2v9.5A1.5 1.5 0 0 0 1.5 14h.653a5.373 5.373 0 0 1 1.066-2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v9h-2.219c.554.654.89 1.373 1.066 2h.653a1.5 1.5 0 0 0 1.5-1.5V3a2 2 0 0 0-2-2H2Z"
              ></path>
            </svg>
            <span class="position-relative"
              >کارگاه

              <!-- <span
                class="position-absolute fs10px top-50N start-100 translate-middle badge rounded-pill bg-danger"
              >
                بزودی ...
                <span class="visually-hidden">unread messages</span>
              </span> -->
            </span>
          </a>
          <span></span>
        </div>
      </div>
    </nav>

    <!-- second nav -->
    <!-- :class="
            this.$router.currentRoute.value.name.includes('sessionsTab')
              ? 'mobile-nav-item-active'
              : ''
          " -->
    <nav class="mobile-nav blueBackground" v-if="isMobile">
      <div class="row col-12">
        <div
          class="col-3 text-center fs-7 m-auto"
          :class="
            this.$router.currentRoute.value.name.includes(
                        'sessionsTab'
                      )
              ? 'mobile-nav-item-active'
              : ''
          "
        >
          <a
            @click="sesstionButtonClick"
            class="mobile-nav-item d-flex flex-column align-items-center"
            style="font-size: 0.7rem"
          >
            <svg
              width="18px"
              height="18px"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="mb-1"
            >
              <path
                fill-rule="evenodd"
                d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
              ></path>
              <path
                fill-rule="evenodd"
                d="M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3zm4.354 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
              ></path>
            </svg>
            سوابق جلسات
          </a>
          <span></span>
        </div>
        <!-- :class="
            this.$router.currentRoute.value.name.includes('walletTab')
              ? 'mobile-nav-item-active'
              : ''
          " -->
        <div
          class="col-3 text-center fs-7 m-auto"
          :class="
            this.$router.currentRoute.value.name.includes(
                        'walletTab'
                      )
              ? 'mobile-nav-item-active'
              : ''
          "
        >
          <a
            @click="walletButtonClick"
            class="mobile-nav-item d-flex flex-column align-items-center"
            style="font-size: 0.7rem"
          >
            <svg
              width="18px"
              height="18px"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="mb-1"
            >
              <path
                d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"
              ></path>
              <path
                d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"
              ></path>
            </svg>
            کیف پول
          </a>
          <span></span>
        </div>
        <!-- :class="
            this.$router.currentRoute.value.name.includes('violationReportTab')
              ? 'mobile-nav-item-active'
              : ''
          " -->
        <div
          class="col-3 text-center fs-7 m-auto p-0"
          :class="
            this.$router.currentRoute.value.name.includes(
                        'violationReportTab'
                      )
              ? 'mobile-nav-item-active'
              : ''
          "
        >
          <a
            @click="violationButtonClick"
            id="reportTherapistFault"
            class="mobile-nav-item d-flex flex-column align-items-center"
            style="font-size: 0.7rem"
          >
            <svg
              width="18px"
              height="18px"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="mb-1"
            >
              <path
                d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
              ></path>
              <path
                d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"
              ></path>
            </svg>
            گزارش خطای درمانگر
          </a>
          <span></span>
        </div>
        <!-- :class="
            this.$router.currentRoute.value.name.includes('discountCode')
              ? 'mobile-nav-item-active'
              : ''
          " -->
        <div
          class="col-3 text-center fs-7 m-auto p-0"
          :class="
            this.$router.currentRoute.value.name.includes(
                        'discountCode'
                      )
              ? 'mobile-nav-item-active'
              : ''
          "
        >
          <!-- :href="`/panel/discountCode/${$store.getters.userPersonID}`" -->
          <a
            @click="discountCodeButtonClick"
            class="mobile-nav-item d-flex flex-column align-items-center"
            style="font-size: 0.7rem"
          >
            <svg
              width="18px"
              height="18px"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="mb-1"
            >
              <path
                d="M7.84 4.1a.178.178 0 0 1 .32 0l.634 1.285a.178.178 0 0 0 .134.098l1.42.206c.145.021.204.2.098.303L9.42 6.993a.178.178 0 0 0-.051.158l.242 1.414a.178.178 0 0 1-.258.187l-1.27-.668a.178.178 0 0 0-.165 0l-1.27.668a.178.178 0 0 1-.257-.187l.242-1.414a.178.178 0 0 0-.05-.158l-1.03-1.001a.178.178 0 0 1 .098-.303l1.42-.206a.178.178 0 0 0 .134-.098L7.84 4.1z"
              ></path>
              <path
                d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"
              ></path>
            </svg>
            کد تخفیف
          </a>
          <span></span>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import axios from 'axios';
// import { useRoute } from 'vue-router';
import { isMobile } from 'mobile-device-detect';
import LoadingSpinner from '../../components/utility/loadingSpinner/LoadingSpinner.vue';
export default {
  expose: ['doSomeMagic'],
  components: {
    LoadingSpinner,
  },
  computed: {
    getHasUnseenMessage() {
      return (this.$store.getters.userHasUnseenMessage ?? 'false') === 'true';
    },
    getUserFullName() {
      return this.$store?.getters?.userFullName.trim()
        ? this.$store?.getters?.userFullName
        : 'کاربر میهمان';
    },
    getClientCode() {
      return this.$store?.getters?.clientCode
        ? this.$store?.getters?.clientCode
        : '';
    },
  },
  inject: [
    'logout',
    'semiReserveListCount',
    'semiReserveList',
    'showClientChooseDialog',
    'cancelReserveSession',
    'contactUsClick',
    'getDiscountTariffPriceList',
    'showDiscountSessionsModal',
    'getCurrentDiscountTariffPrice',
  ],
  data() {
    return {
      clientTherapistList: [],
      demoImageUrl: '/img/No_Avatar.png',
      isMenueActive: false,
      walletList: [],
      isMobile: isMobile,
      hasProfilePic: false,
      isLoading: true,
      // currentPanel: 'therapySession',
    };
  },
  // props: {
  //   forcedTab: {
  //     type: String,
  //     required: false,
  //   },
  // },
  watch: {
    async $route(to, from) {
      if (
        to.path != from.path &&
        (to.fullPath.includes('/panel/walletTab') ||
          to.fullPath.includes('/panel/userPanel'))
      ) {
        await this.refreshWalletList();
        await this.getClientsTherapists();
        // this.clientID = this.$route.params.id;
        // await this.getProfilePicture();
      }
    },
  },
  methods: {
    getHourAndMinute(data) {
      return `${data.split(':')[0]}:${data.split(':')[1]}`;
    },
    getPersianDate(date) {
      // eslint-disable-next-line
      return new persianDate(new Date(date)).format('L');
    },
    getGregorianDateOfSession(date) {
      // eslint-disable-next-line
      return getGregorianDate(date);
    },
    async getProfilePicture() {
      let that = this;
      this.$refs.spinner.show();

      await axios
        .get(
          `/FS/ProfilePicture/GetProfilePicture/${that.$store.getters.userPersonID}`,
          {
            responseType: 'blob',
          }
        )
        .then((response) => {
          if (response.data && response.data.size > 0) {
            that.demoImageUrl = URL.createObjectURL(response.data);
            that.hasProfilePic = true;
          } else {
            that.hasProfilePic = false;
          }
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    checkMultipleClients() {
      let clientList = this.$store.getters.clientList;
      return clientList && clientList.length > 0;
    },
    getWalletList() {
      return this.walletList;
    },
    getClientOverseas() {
      return this.$store.getters.isOverseas;
    },
    getClientPhone() {
      return this.$store.getters.phone ?? '';
    },
    getClientEmail() {
      return this.$store.getters.email ?? '';
    },
    async refreshWalletList() {
      let that = this;
      if (!that.$store.getters.userPersonID) {
        return;
      }
      await axios
        .get(
          `/FN/Wallet/GetPersonWalletsForSite/${that.$store.getters.userPersonID}`
        )
        .then((response) => {
          that.walletList = response.data;
        })
        .catch(() => {
          that.$refs.notification.show({
            type: 'error',
            title: 'دریافت کیف پول‌های کاربر با خطا مواجه گردید.',
          });
        });
    },
    getFormatedBalance(price) {
      // if (!price) return;
      // eslint-disable-next-line
      return thousandSeprator(price);
    },
    thousandSeprator(number, seprator, decimalPointer) {
      // eslint-disable-next-line
      return thousandSeprator(number, seprator, decimalPointer);
    },
    btnMenuClick() {
      'd-none d-sm-block shadow-md border animate-fadein rounded p-3'
        .split(' ')
        .forEach((f) => {
          this.$refs.nav_responsiveMenu.classList.toggle(f);
        });
      this.isMenueActive = !this.isMenueActive;
    },
    getMyTherapistList() {
      return this.clientTherapistList;
    },
    async getClientsTherapists() {
      let that = this;
      await axios
        .get(
          '/Basic/Therapist/GetClientsTherapists?personID=' +
            this.$store.getters.userPersonID
        )
        .then((response) => {
          that.clientTherapistList = response.data;
          //اگر این کاربر جلسه ای نگرفته باشد، گزارش تخطی غیرفعال شود
          if (response.data.length == 0) {
            document
              .getElementById('reportTherapistFault')
              .classList.add('disabled');
          } else {
            document
              .getElementById('reportTherapistFault')
              .classList.remove('disabled');
          }
        })
        .catch(() => {
          that.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات درمانگران کاربر با خطا مواجه گردید.`,
          });
        });
    },
    reservingSessionButtonClick() {
      this.$store.dispatch('setClientCurrentPanel', 'therapySession');
      this.$router.push({
        name: 'selectTherapist',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    reserveTestButtonClick() {
      this.$store.dispatch('setClientCurrentPanel', 'testSession');
      this.$router.push({
        name: 'selectTestSession',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    sesstionButtonClick() {
      this.$store.dispatch('setClientCurrentPanel', 'sessionList');
      this.$router.push({
        name: 'sessionsTab',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    walletButtonClick() {
      this.$store.dispatch('setClientCurrentPanel', 'walletList');
      this.$router.push({
        name: 'walletTab',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    violationButtonClick() {
      this.$store.dispatch('setClientCurrentPanel', 'violationReportList');
      this.$router.push({
        name: 'violationReportTab',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    discountCodeButtonClick() {
      this.$store.dispatch('setClientCurrentPanel', 'discountList');
      this.$router.push({
        name: 'discountCode',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    workshopButtonClick() {
      this.$store.dispatch('setClientCurrentPanel', 'workshopList');
      this.$router.push({
        name: 'workshopTab',
        params: { id: this.$store.getters.userPersonID, type: 2 },
      });
    },
    groupTherapyButtonClick() {
      this.$store.dispatch('setClientCurrentPanel', 'groupTherapyList');
      // this.$router.push({
      //   name: 'groupTherapyTab',
      //   params: { id: this.$store.getters.userPersonID, type: 1 },
      // });
      this.$router.push({
        name: 'workshopTab',
        params: { id: this.$store.getters.userPersonID, type: 1 },
      });
    },
  },
  provide() {
    return {
      WalletList: this.getWalletList,
      RefreshWalletList: this.refreshWalletList,
      getMyTherapistList: this.getMyTherapistList,
      GetProfilePicture: this.getProfilePicture,
    };
  },
  async beforeMount() {
    //به دلیل تداخل همزمانی، این متد در زمانی که در انتخاب درمانگر در ثبت جلسه بود اجرا نشود
    if (this.$router.currentRoute.value.name != 'selectTherapist')
      await this.getClientsTherapists();

    if (this.$router.currentRoute.value.name != 'reservingSessionTab') {
      await this.$store
        .dispatch('setClientWithWallet', this.$store.getters.userPersonID)
        .then(async () => {
          await this.getCurrentDiscountTariffPrice();
        });
    }
  },
  async mounted() {
    await this.getProfilePicture();
    // document.getElementById('app').style.height = '100vh';
    //get Wallet list for all child
    // const route = useRoute();
    if (this.forcedTab) {
      this.tabSelected = this.forcedTab;
    }

    // this.clientID = route.params.id;

    //به منظور کنترل تقدم و تاخیر نمایش کامپوننت ها گذاشته شده است تا ساعتی که جواب کیف پول بازنگشته بود فرم ها لود نشود
    // بعد از بازگشت جواب کیف پول ها فرم ها لود شود تا مقدار کیف پول برای آنها پر باشد
    if (!this.$router.currentRoute.value.path.includes('invoiceList')) {
      this.$refs.spinner.show();

      this.isLoading = true;

      await this.refreshWalletList();
      this.isLoading = false;
      this.$refs.spinner.hide();
    }
  },
};
</script>
<style>
.fs-7 {
  font-size: 0.9rem !important;
}
.fs-8 {
  font-size: 0.8rem !important;
}
.mobile-nav {
  right: 0;
  z-index: 100;
  /* position: fixed; */
  /* position: relative; */
  /* bottom: 0px; */
  height: 65px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  /* box-shadow: -3px 2px 20px 0px #eee !important; */
}
.div:has(> a.active) {
  border: 2px solid red;
}
.mobile-nav-item {
  color: white !important;
}
.mobile-nav-item:focus,
.mobile-nav-item:active,
.mobile-nav-item-active > a {
  color: #f5b003 !important;
}
.mobile-nav-item-active {
  margin-bottom: 0px !important;
  padding-bottom: 2px;
  /* transform: scale(0.85); */
  /* transition: all 1s; */
}
.mobile-nav-item-active > span {
  display: block;
  border-bottom: 5px solid #f5b003;
  animation: blink 0.5s;
}
@keyframes blink {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
nav.nav-deep-light .nav-item.active > .nav-link {
  color: #f9c641 !important;
}
.blueBackground {
  background-color: #3d4964;
}
.blueText {
  color: #3d4964;
}
.rg-btn-container-foreground {
  background-color: #3d4964 !important;
  color: white !important;
  box-shadow: -3px 2px 20px 0px #eee !important;
}
.pnael-menu .nav-item > a.nav-link {
  color: white !important;
  padding: 15px;
  font-size: 16px;
}
.pnael-menu .nav-item > a.nav-link svg {
  width: 20px !important;
  height: 20px !important;
}
.pnael-menu .nav-item > a.nav-link:hover {
  /* color: #a8b7ce !important; */
  color: #f9c641 !important;
}
.bg-mainPanel {
  background-color: #f3f3f3 !important;
  /* min-height: 400px; */
  min-height: 40vh;
}

@media (min-width: 991.98px) {
  .bg-RightMenu {
    /* background-color: #63707e !important; */
    background-color: #4c5e74 !important;
    min-height: max(700px, 80vh);
  }
}

.bg-RightMenu {
  /* background-color: #63707e !important; */
  background-color: #4c5e74 !important;
  /* min-height: 80vh; */
}
.mobileHeigh {
  height: 60vh;
}
.sticky-kit {
  position: sticky;
  top: 0px;
}
</style>
